import Header from "@/components/header/Header.vue";
import Footer from "@/components/footer/Footer.vue";
import { useToast } from 'vue-toastification';
import axios from '@/config/axios';
const toast = useToast();

export default {
  name: 'SearchPreferences',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      isLoading: false,
      isGenresLoading: false,
      accountName: '',
      prefMood: 'none',
      prefBookType: 'none',
      prefGenres: [],
      prefGoal: 'none',
      prefFreeText: '',
      originalPreferences: null,
      currentStep: 1,
      searchGenreQuery: '',
      moodOptions: [
        { value: 'none', emoji: '🌀', label: 'Tùy ý, Ngẫu nhiên', description: 'Gợi ý mọi thể loại sách đa dạng cho bạn' },
        { value: 'relaxed', emoji: '🌿', label: 'Thư thái, nhẹ nhàng', description: 'Đọc để thả lỏng tâm trí sau ngày làm việc' },
        { value: 'motivated', emoji: '🔥', label: 'Cần động lực, cảm hứng', description: 'Tìm năng lượng tích cực, bài học cuộc sống' },
        { value: 'curious', emoji: '🔭', label: 'Tò mò, khám phá', description: 'Khám phá tri thức mới, phiêu lưu kỳ bí' },
        { value: 'stressed', emoji: '😄', label: 'Căng thẳng, muốn giải tỏa', description: 'Đọc truyện cười, hài hước, giải trí nhẹ' }
      ],
      bookTypeOptions: [
        { value: 'none', emoji: '📚', label: 'Phong cách bất kỳ', description: 'Không giới hạn hình thức hay độ dài của sách' },
        { value: 'bestsellers', emoji: '🏆', label: 'Sách bán chạy & Thịnh hành', description: 'Những cuốn sách được đọc nhiều nhất gần đây' },
        { value: 'classics', emoji: '⏳', label: 'Tác phẩm kinh điển', description: 'Những giá trị vượt thời gian, trường tồn lâu năm' },
        { value: 'short', emoji: '⚡', label: 'Sách ngắn / Đọc nhanh', description: 'Dưới 200 trang, dễ dàng hoàn thành trong ngày' },
        { value: 'deep', emoji: '🔬', label: 'Sách chuyên sâu / Nghiên cứu', description: 'Nội dung dày dặn, đòi hỏi tập trung suy ngẫm' }
      ],
      genreOptions: [],
      goalOptions: [
        { value: 'none', emoji: '🎲', label: 'Đọc tự do, ngẫu hứng', description: 'Không gò bó mục tiêu, đọc bất cứ khi nào thấy thích' },
        { value: 'soul', emoji: '🌸', label: 'Nuôi dưỡng tâm hồn', description: 'Tìm sự bình yên, thư giãn qua các câu chuyện đẹp' },
        { value: 'career', emoji: '🚀', label: 'Nâng cao kiến thức', description: 'Phát triển kỹ năng nghề nghiệp, mở rộng sự nghiệp' },
        { value: 'entertainment', emoji: '🎭', label: 'Giải trí & Thư giãn', description: 'Truyện ly kỳ, hồi hộp, giết thời gian' },
        { value: 'habit', emoji: '📅', label: 'Rèn thói quen đọc sách', description: 'Duy trì tần suất đọc đều đặn, tích lũy kiến thức' }
      ]
    };
  },
  computed: {
    isFromRegister() {
      return this.$route.query.from === 'register';
    },
    filteredGenreOptions() {
      let list = [...this.genreOptions];
      list = list.filter(opt => !this.prefGenres.includes(opt.value));
      if (this.searchGenreQuery) {
        const query = this.searchGenreQuery.toLowerCase().trim();
        list = list.filter(opt =>
          opt.label.toLowerCase().includes(query)
        );
      }
      return list.sort((a, b) => {
        return a.label.localeCompare(b.label, 'vi', { sensitivity: 'base' });
      });
    },
    selectedGenres() {
      return this.genreOptions.filter(opt => this.prefGenres.includes(opt.value));
    }
  },
  mounted() {
    if (this.$route.path === '/search-preferences' && !this.isFromRegister) {
      this.$router.replace('/settings/preferences');
      return;
    }
    const currentAccountStr = localStorage.getItem('current-account');
    if (currentAccountStr) {
      try {
        const currentAccount = JSON.parse(currentAccountStr);
        this.accountName = currentAccount.fullName || currentAccount.name || currentAccount.username || '';

        // Fetch existing search preferences from DB
        const userId = currentAccount.id || currentAccount.username || 'guest';
        axios.get('behavioral-analysis/get')
          .then(res => {
            if (res.data.status === '200' && res.data.result) {
              const result = res.data.result;
              this.prefMood = this.getValueFromLabel(result.mood, this.moodOptions);
              this.prefBookType = this.getValueFromLabel(result.style, this.bookTypeOptions);
              this.prefGoal = this.getValueFromLabel(result.target, this.goalOptions);
              this.prefFreeText = result.description || '';

              if (result.categories) {
                try {
                  this.prefGenres = JSON.parse(result.categories) || [];
                } catch (parseCategoriesErr) {
                  console.error('Error parsing categories:', parseCategoriesErr);
                  this.prefGenres = [];
                }
              } else {
                this.prefGenres = [];
              }

              // Keep local storage in sync
              const preferences = {
                mood: this.prefMood,
                bookType: this.prefBookType,
                genres: this.prefGenres,
                goal: this.prefGoal,
                freeText: this.prefFreeText
              };
              this.originalPreferences = JSON.parse(JSON.stringify(preferences));
              localStorage.setItem(`search_preferences_${userId}`, JSON.stringify(preferences));
            } else {
              // Fallback to localStorage if no DB entry exists yet
              const savedPrefsStr = localStorage.getItem(`search_preferences_${userId}`);
              if (savedPrefsStr) {
                const savedPrefs = JSON.parse(savedPrefsStr);
                this.prefMood = savedPrefs.mood || 'none';
                this.prefBookType = savedPrefs.bookType || 'none';
                this.prefGenres = savedPrefs.genres || [];
                this.prefGoal = savedPrefs.goal || 'none';
                this.prefFreeText = savedPrefs.freeText || '';
              }
              this.originalPreferences = JSON.parse(JSON.stringify({
                mood: this.prefMood,
                bookType: this.prefBookType,
                genres: this.prefGenres,
                goal: this.prefGoal,
                freeText: this.prefFreeText
              }));
            }
          })
          .catch(err => {
            console.error('Error fetching preferences:', err);
            // Fallback to localStorage on error
            const savedPrefsStr = localStorage.getItem(`search_preferences_${userId}`);
            if (savedPrefsStr) {
              const savedPrefs = JSON.parse(savedPrefsStr);
              this.prefMood = savedPrefs.mood || 'none';
              this.prefBookType = savedPrefs.bookType || 'none';
              this.prefGenres = savedPrefs.genres || [];
              this.prefGoal = savedPrefs.goal || 'none';
              this.prefFreeText = savedPrefs.freeText || '';
            }
            this.originalPreferences = JSON.parse(JSON.stringify({
              mood: this.prefMood,
              bookType: this.prefBookType,
              genres: this.prefGenres,
              goal: this.prefGoal,
              freeText: this.prefFreeText
            }));
          });
      } catch (e) {
        console.error('Error loading account:', e);
      }
    }
    this.fetchGenres();
  },
  methods: {
    handleSave() {
      this.isLoading = true;
      const currentAccountStr = localStorage.getItem('current-account');
      if (currentAccountStr) {
        try {
          const currentAccount = JSON.parse(currentAccountStr);
          const userId = currentAccount.id || currentAccount.username || 'guest';

          const payload = {
            description: this.prefFreeText || '',
            categories: JSON.stringify(this.prefGenres || []),
            mood: this.getLabelFromValue(this.prefMood, this.moodOptions),
            style: this.getLabelFromValue(this.prefBookType, this.bookTypeOptions),
            target: this.getLabelFromValue(this.prefGoal, this.goalOptions)
          };

          const preferences = {
            mood: this.prefMood,
            bookType: this.prefBookType,
            genres: this.prefGenres,
            goal: this.prefGoal,
            freeText: this.prefFreeText
          };
          const prefJson = JSON.stringify(preferences);
          
          let isChanged = true;
          if (this.originalPreferences) {
             isChanged = JSON.stringify(preferences) !== JSON.stringify(this.originalPreferences);
          }

          axios.post('behavioral-analysis/save', payload)
            .then(res => {
              if (res.data.status === '200') {
                localStorage.setItem(`search_preferences_${userId}`, prefJson);
                this.originalPreferences = JSON.parse(prefJson);
                toast.success('Lưu cấu hình cá nhân hóa thành công!');
                
                if (isChanged) {
                  window.dispatchEvent(new CustomEvent('preferences-updated'));
                }

                setTimeout(() => {
                  this.isLoading = false;
                  if (this.isFromRegister) {
                    this.$router.push('/');
                  }
                }, 800);
              } else {
                this.isLoading = false;
                toast.error(res.data.message || 'Có lỗi xảy ra khi lưu sở thích!');
              }
            })
            .catch(err => {
              console.error('Error saving preferences:', err);
              this.isLoading = false;
              toast.error('Không thể kết nối đến máy chủ để lưu sở thích!');
            });
        } catch (e) {
          this.isLoading = false;
          toast.error('Có lỗi xảy ra khi xử lý dữ liệu!');
        }
      } else {
        this.isLoading = false;
        toast.error('Vui lòng đăng nhập để thực hiện chức năng này.');
        this.$router.push('/login');
      }
    },
    getLabelFromValue(val, options) {
      const opt = options.find(o => o.value === val);
      return opt ? opt.label : '';
    },
    getValueFromLabel(label, options) {
      if (!label) return 'none';
      const opt = options.find(o => o.label === label);
      return opt ? opt.value : 'none';
    },
    skipUpdate() {
      this.$router.push('/');
    },
    nextStep() {
      if (this.currentStep < 3) {
        this.currentStep++;
      }
    },
    prevStep() {
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },
    autoResize() {
      const el = this.$refs.freetextArea;
      if (el) {
        el.style.height = 'auto';
        el.style.height = el.scrollHeight + 'px';
      }
    },
    fetchGenres() {
      this.isGenresLoading = true;
      // Icon map: match by keyword in category name
      const iconMap = [
        { keywords: ['văn học', 'tiểu thuyết', 'truyện'], icon: 'fa-solid fa-feather' },
        { keywords: ['kỹ năng', 'phát triển', 'self'], icon: 'fa-solid fa-graduation-cap' },
        { keywords: ['khoa học', 'công nghệ', 'tech'], icon: 'fa-solid fa-atom' },
        { keywords: ['lịch sử', 'triết', 'chính trị'], icon: 'fa-solid fa-landmark' },
        { keywords: ['tâm lý', 'sức khỏe', 'tâm linh'], icon: 'fa-solid fa-brain' },
        { keywords: ['tranh', 'nghệ thuật', 'manga', 'comic'], icon: 'fa-solid fa-palette' },
        { keywords: ['kinh tế', 'tài chính', 'kinh doanh'], icon: 'fa-solid fa-chart-line' },
        { keywords: ['thiếu nhi', 'trẻ em'], icon: 'fa-solid fa-child' },
        { keywords: ['phiêu lưu', 'viễn tưởng', 'fantasy'], icon: 'fa-solid fa-dragon' },
        { keywords: ['nấu ăn', 'ẩm thực'], icon: 'fa-solid fa-utensils' },
      ];
      function pickIcon(name) {
        if (!name) return 'fa-solid fa-book';
        const lower = name.toLowerCase();
        for (const entry of iconMap) {
          if (entry.keywords.some(k => lower.includes(k))) return entry.icon;
        }
        return 'fa-solid fa-book';
      }
      axios.get('category/v1/get-all', { _skip403Redirect: true })
        .then(response => {
          const data = response.data;
          if (data.status === '200' && data.result) {
            const list = Array.isArray(data.result) ? data.result : (data.result.content || []);
            this.genreOptions = list.map(cat => ({
              value: cat.id || String(cat.id) || cat.name,
              label: cat.name || cat.title || cat.categoryName || '',
              icon: pickIcon(cat.name || cat.title || '')
            }));
          } else {
            // Fallback to static list if status is not 200
            this.loadStaticFallbackGenres();
          }
        })
        .catch(err => {
          console.error('Failed to load categories from API, loading static fallbacks:', err);
          this.loadStaticFallbackGenres();
        })
        .finally(() => {
          this.isGenresLoading = false;
        });
    },
    loadStaticFallbackGenres() {
      const fallbackList = [
        { name: "Văn học & Tiểu thuyết" },
        { name: "Kỹ năng & Phát triển" },
        { name: "Khoa học & Công nghệ" },
        { name: "Lịch sử & Triết học" },
        { name: "Tâm lý học & Sức khỏe" },
        { name: "Truyện tranh & Nghệ thuật" },
        { name: "Kinh tế & Kinh doanh" }
      ];
      // Icon mapping
      const iconMap = [
        { keywords: ['văn học', 'tiểu thuyết', 'truyện'], icon: 'fa-solid fa-feather' },
        { keywords: ['kỹ năng', 'phát triển', 'self'], icon: 'fa-solid fa-graduation-cap' },
        { keywords: ['khoa học', 'công nghệ', 'tech'], icon: 'fa-solid fa-atom' },
        { keywords: ['lịch sử', 'triết', 'chính trị'], icon: 'fa-solid fa-landmark' },
        { keywords: ['tâm lý', 'sức khỏe', 'tâm linh'], icon: 'fa-solid fa-brain' },
        { keywords: ['tranh', 'nghệ thuật', 'manga', 'comic'], icon: 'fa-solid fa-palette' },
        { keywords: ['kinh tế', 'tài chính', 'kinh doanh'], icon: 'fa-solid fa-chart-line' },
      ];
      function pickIcon(name) {
        if (!name) return 'fa-solid fa-book';
        const lower = name.toLowerCase();
        for (const entry of iconMap) {
          if (entry.keywords.some(k => lower.includes(k))) return entry.icon;
        }
        return 'fa-solid fa-book';
      }
      this.genreOptions = fallbackList.map((cat, index) => ({
        value: cat.name,
        label: cat.name,
        icon: pickIcon(cat.name)
      }));
    }
  }
};
